// Client feature flags — mirrored manually with
// supabase/functions/_shared/featureFlags.ts where a server counterpart exists.

// Existing flags (preserved).
export const NOTIFY_ON_READY = false;
export const UNIFIED_PENDING = false;

// Wave 5 Phase 1 — freemium quota (client mirror).
// Phase 2 will consume PAYWALL_ENFORCEMENT_ENABLED to conditionally render
// the paywall UI. While false, no user-facing behavior changes.
export const PAYWALL_ENFORCEMENT_ENABLED = false;
export const FREE_MONTHLY_OUTFIT_QUOTA = 5;

// Wave 5 Phase 2 — client-side paywall UI gate.
// While false, invokeGenerator still catches 402 responses defensively but
// logs + toasts instead of navigating to /paywall. Flipping to true (paired
// with Phase 5 server flag flip) activates the placeholder paywall route.
export const PAYWALL_UI_ENABLED = false;

// Wave 5 Phase 3a — RevenueCat SDK gate.
// While false, initRevenueCat() aborts before Purchases.configure() and no
// SDK network calls fire. Phase 3c flips to true after Ola confirms
// TestFlight build + RevenueCat dashboard webhook is configured.
export const REVENUECAT_ENABLED = false;

